import { AfterViewInit, Component, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule, NzIconService } from 'ng-zorro-antd/icon';
import { NzInputDirective, NzInputGroupComponent, NzInputGroupWhitSuffixOrPrefixDirective } from 'ng-zorro-antd/input';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzTableCellDirective, NzTableComponent, NzTableModule, NzTableQueryParams } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { TITLE_TABLE_SIZE } from 'src/app/core/constants/style';
import { PauseService } from '../../services/pause.service';
import { ProductionPauseDto } from 'src/app/shared/dto/production-pause.dto';
import { CommonModule, DatePipe } from '@angular/common';
import _ from 'lodash';
import { Subject, takeUntil } from 'rxjs';
import { UserLoggedService } from 'src/app/core/services/userLogged.service';
import { UserDto } from 'src/app/shared/dto/user.dto';
import { IconDefinition } from '@ant-design/icons-angular';
import { CloseCircleTwoTone, CheckCircleTwoTone, FormOutline } from '@ant-design/icons-angular/icons';
import { differenceInCalendarDays } from 'date-fns';
import { UserService } from '../../services/user.service';
import { ModalCreatePauseComponent } from '../../components/modals/modal-create-pause/modal-create-pause.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DefaultComponent } from 'src/app/shared/services/view.service';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';

const icons: IconDefinition[] = [
    CheckCircleTwoTone,
    CloseCircleTwoTone,
    FormOutline
];

@Component({
    selector: 'app-validate-pauses',
    standalone: true,
    imports: [
        CommonModule,
        NzPageHeaderModule,
        NzSpaceModule,
        NzDividerModule,
        NzDrawerModule,
        NzDatePickerModule,
        FormsModule,
        NzMessageModule,
        NzTableModule,
        NzTableComponent,
        NzTableCellDirective,
        NzSelectModule,
        NzInputDirective,
        ReactiveFormsModule,
        NzInputDirective,
        NzFormModule,
        NzCheckboxModule,
        NzDropDownModule,
        NzIconModule,
        NzToolTipModule,
        DatePipe,
        NzInputGroupComponent,
        NzInputGroupWhitSuffixOrPrefixDirective,
        NzInputDirective,
        NzDatePickerModule,
        LoaderComponent
    ],
    templateUrl: './validate-pauses.component.html',
    styleUrl: './validate-pauses.component.scss'
})
export class ValidatePausesComponent extends DefaultComponent implements OnInit, AfterViewInit, OnDestroy {

    userLogged: UserDto;
    isLoading: boolean = false;
    pauses: ProductionPauseDto[] = [];
    tableHeight!: number;

    totalPauses: number = 0;
    pageSize: number = 10;
    pageIndex: number = 1;

    today = new Date();
    timeDefaultValue = new Date();
    fromDate: Date | null = null;
    toDate: Date | null = null;

    filterPausedBy: { text: string, value: number, byDefault: boolean }[] = [];
    filterResumedBy: { text: string, value: number, byDefault: boolean }[] = [];
    filterValidatedBy: { text: string, value: number, byDefault: boolean }[] = [];
    filterAccepted: { text: string, value: boolean, byDefault: boolean }[] = [{ text: 'Sí', value: true, byDefault: false }, { text: 'No', value: false, byDefault: false }];
    filterStatus: string = 'NO_REVIEWED';
    filterText: string = '';
    filterPausedByIds: string = '';
    filterResumedByIds: string = '';
    filterValidatedByIds: string = '';
    filterAcceptedValues: string = '';
    sortByStartDate: string = 'ascend';

    @ViewChild('tableContainer') private readonly _tableContainer!: ElementRef;

    private unsubscribe$ = new Subject<void>();

    private readonly message = inject(NzMessageService);
    private readonly pauseService = inject(PauseService);
    private readonly iconService = inject(NzIconService);
    private readonly userLoggedService = inject(UserLoggedService);
    private readonly userService = inject(UserService);
    private readonly modalService = inject(NzModalService);

    constructor() {
        super('validatePauses', '');
        this.iconService.addIcon(...icons);

        this.userLogged = _.cloneDeep(this.userLoggedService.userLogged);

        this.totalPauses = 0;
        this.pageSize = 10;
        this.pageIndex = 1;
    }

    async ngOnInit() {
        try {
            this.isLoading = true;

            const users = await this.userService.getUsers();
            for (const user of users) {
                this.filterPausedBy.push({ text: user.name, value: user.id, byDefault: false });
                this.filterResumedBy.push({ text: user.name, value: user.id, byDefault: false });
                this.filterValidatedBy.push({ text: user.name, value: user.id, byDefault: false });
            }

            this.filterPausedBy = _.cloneDeep(this.filterPausedBy);
            this.filterResumedBy = _.cloneDeep(this.filterResumedBy);
            this.filterValidatedBy = _.cloneDeep(this.filterValidatedBy);

            await this.pauseService.setupWebSocket(this.pageSize, this.pageIndex, this.filterStatus);
            
            this.pauseService.pauses$
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                    next: (pauseResponse) => {
                        this.pauses = pauseResponse.productionPauses;
                        this.totalPauses = pauseResponse.totalProductionPauses;
                    },
                    error: () => {
                        this.message.error('Error cargando pausas');
                    }
                });

            this.isLoading = false;
        } catch (e: any) {
            this.isLoading = false;
            this.message.create('error', `${e.message}`);
        }
    }

    async ngAfterViewInit(): Promise<void> {
        setTimeout(() => {
            this.tableHeight =
                (this._tableContainer.nativeElement as HTMLImageElement)
                    .clientHeight - TITLE_TABLE_SIZE;
        });
    }

    ngOnDestroy(): void {
        this.pauseService.disconnectWebSocket();
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    async changeFilterStatus(status: string) {
        this.filterStatus = status;
        await this.getPaginatedPauses();
    }

    async clearFilter(): Promise<void> {
        this.filterText = '';
        await this.getPaginatedPauses();
    }

    async onQueryParamsChange(params: NzTableQueryParams): Promise<void> {
        const { pageSize, pageIndex, sort, filter } = params;

        this.filterPausedByIds = filter.find(filter => filter.key === 'filterPausedBy')?.value?.toString() ?? (this.canReadPausesSubKey('canEditOtherUsers') ? '' : this.userLogged.id.toString());
        this.filterResumedByIds = filter.find(filter => filter.key === 'filterResumedBy')?.value?.toString() ?? (this.canReadPausesSubKey('canEditOtherUsers') ? '' : this.userLogged.id.toString());
        this.filterValidatedByIds = filter.find(filter => filter.key === 'filterValidatedBy')?.value?.toString() ?? '';
        this.filterAcceptedValues = filter.find(filter => filter.key === 'filterAccepted')?.value?.toString() ?? '';
        this.sortByStartDate = sort.find(sort => sort.key === 'startDate')?.value?.toString() ?? 'ascend';

        this.pageSize = pageSize;
        this.pageIndex = pageIndex;

        await this.getPaginatedPauses();
    }

    async onChangeDatePickers() {
        await this.getPaginatedPauses();
    }

    async getPaginatedPauses() {
        this.isLoading = true;
        const pausesResponse = await this.pauseService.getPaginatedPauses(this.pageSize, this.pageIndex, this.filterStatus, this.filterText, this.filterPausedByIds, this.filterResumedByIds, this.filterValidatedByIds, this.filterAcceptedValues, this.fromDate, this.toDate, this.sortByStartDate);
        this.pauses = pausesResponse.productionPauses;

        this.totalPauses = pausesResponse.total;
        this.pageIndex = pausesResponse.page ?? this.pageIndex;
        this.pauseService.refreshVariables(this.pageSize, this.pageIndex, this.filterStatus, this.filterText, this.filterPausedByIds, this.filterResumedByIds, this.filterValidatedByIds, this.filterAcceptedValues, this.fromDate, this.toDate, this.sortByStartDate);
        this.isLoading = false;
    }

    async validateById(pauseId: number, accepted: boolean) {
        await this.pauseService.validateById({ pauseId: pauseId, accepted: accepted, validatedById: this.userLogged.id });
    }

    editPause(pause: ProductionPauseDto) {
        const modal = this.modalService.create({
            nzContent: ModalCreatePauseComponent,
            nzStyle: { width: '70%', top: '20%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzData: {
                nzTitle: `Editar pausa - Orden ${pause.productionOrderProcess?.id} | ${pause.productionOrderProcess?.description} | Pausa ${pause?.id}`,
                orderProcessId: pause.productionOrderProcess?.id,
                orderProcessDescription: pause.productionOrderProcess?.description,
                previousStatusId: pause.productionOrderProcess?.statusId,
                machineId:  pause.productionOrderProcess?.machineId,
                pause: pause
            }
        });

        modal.componentInstance?.emitService.subscribe(async (response: ProductionPauseDto) => {
            if (response) {
                this.message.success('Pausa actualizada correctamente');
            }
        });
    }

    milisecondsToFormatTime(start: Date, end: Date): string {
        const millisec: number = end.getTime() - start.getTime();
        let seconds: number = +(millisec / 1000).toFixed(0);
        let minutes: number = Math.floor(seconds / 60);
        let hours: number = 0;

        if (minutes > 59) {
            hours = Math.floor(minutes / 60);
            minutes = minutes - hours * 60;
        }

        seconds = Math.floor(seconds % 60);


        return `${hours >= 10 ? '' : '0'}${hours} : ${minutes >= 10 ? '' : '0'}${minutes} : ${seconds >= 10 ? '' : '0'}${seconds}`;

    }

    disabledDate = (current: Date): boolean =>
        // Can not select days before today and today
        differenceInCalendarDays(current, this.today) > 0;

    canReadPausesSubKey(pausesSubKey: string): boolean {
        const permissionMainKey: string = 'pauses';

        return this.permissionService.canRead(permissionMainKey, `${pausesSubKey}`);
    }

    canReadValidatePausesSubKey(validatePausesSubKey: string): boolean {
        const permissionMainKey: string = 'validatePauses';

        return this.permissionService.canRead(permissionMainKey, `${validatePausesSubKey}`);
    }

    canEditPauses(): boolean {
        const permissionMainKey: string = 'pauses';

        return this.permissionService.canEdit(permissionMainKey, permissionMainKey);
    }
}
